"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _constants = require("./constants");

var _Icons = require("../Icons");

var _Spinner = require("../Spinner");

require("./Button.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var getButtonText = function getButtonText(isDisc, icon, children) {
  if (isDisc) {
    return null;
  } else if (icon) {
    return _react.default.createElement("span", {
      "data-spec": "button-text-wrapper",
      key: "ButtonText"
    }, children);
  }

  return children;
};

var getIcon = function getIcon(IconComponent) {
  if (IconComponent) {
    return _react.default.createElement(IconComponent, {
      key: "ButtonIcon"
    });
  }

  return null;
};

var getSpinner = function getSpinner(isLoading) {
  if (isLoading) {
    return _react.default.createElement(_Spinner.Spinner, {
      className: "btn--react__spinner",
      key: "ButtonSpinner"
    });
  }

  return null;
};

var getTickIcon = function getTickIcon(isSuccess) {
  if (isSuccess) {
    return _react.default.createElement(_Icons.IconUiTickCircle, {
      className: "animated u-color-moogreen",
      key: "ButtonTickIcon"
    });
  }

  return null;
};

var getTooltip = function getTooltip(tooltip) {
  if (tooltip) {
    return _react.default.createElement("div", {
      className: "fade-in-children__child",
      key: "ButtonTooltip"
    }, tooltip);
  }

  return null;
};

var Button = function Button(_ref) {
  var _classNameConfig;

  var className = _ref.className,
      onClick = _ref.onClick,
      href = _ref.href,
      isDisabled = _ref.isDisabled,
      isFullWidth = _ref.isFullWidth,
      size = _ref.size,
      type = _ref.type,
      isDisc = _ref.isDisc,
      label = _ref.label,
      isLoading = _ref.isLoading,
      isSuccess = _ref.isSuccess,
      children = _ref.children,
      IconComponent = _ref.icon,
      tooltip = _ref.tooltip,
      otherProps = _objectWithoutProperties(_ref, ["className", "onClick", "href", "isDisabled", "isFullWidth", "size", "type", "isDisc", "label", "isLoading", "isSuccess", "children", "icon", "tooltip"]);

  var classNameConfig = (_classNameConfig = {
    btn: true,
    'btn--react': true,
    '-is-disabled': isDisabled,
    '-width-100': isFullWidth,
    '-disc': isDisc
  }, _defineProperty(_classNameConfig, "-".concat(size), Object.values(_constants.buttonSizes).includes(size) && size !== _constants.buttonSizes.MEDIUM), _defineProperty(_classNameConfig, "-".concat(type), Object.values(_constants.buttonTypes).includes(type) && type !== _constants.buttonTypes.PRIMARY), _defineProperty(_classNameConfig, '-is-loading', isLoading), _defineProperty(_classNameConfig, '-is-success', isSuccess), _defineProperty(_classNameConfig, 'fade-in-children__parent', !!tooltip), _classNameConfig);
  var icon = !(isLoading || isSuccess) ? getIcon(IconComponent) : null;
  var buttonText = getButtonText(isDisc, IconComponent, children);
  var tooltipComponent = getTooltip(tooltip);
  var spinner = getSpinner(isLoading);
  var tickIcon = getTickIcon(isSuccess);
  var buttonChildren = [icon, buttonText, tooltipComponent, spinner, tickIcon];
  var classes = (0, _classnames.default)(className, classNameConfig);
  var tagName = href ? 'a' : 'button';

  var buttonElement = _react.default.createElement(tagName, _objectSpread({}, otherProps, {
    className: classes,
    disabled: isDisabled,
    onClick: onClick,
    href: href,
    'data-spec': 'button',
    'data-isdisabled': isDisabled,
    'data-isloading': isLoading,
    'data-issuccess': isSuccess
  }), buttonChildren);

  if (label) {
    return _react.default.createElement("span", {
      className: "btn--react__disc-label u-fontFamily-secondaryMedium u-justifyContent-center -".concat(type, " -").concat(size),
      role: "button",
      tabIndex: 0
    }, buttonElement, _react.default.createElement("span", {
      className: "btn--react__disc-label-text -".concat(size),
      onClick: onClick,
      onKeyPress: onClick,
      role: "button",
      tabIndex: 0
    }, label));
  }

  return buttonElement;
};

Button.propTypes = {
  /** A function that is called when the button is clicked. */
  onClick: _propTypes.default.func,

  /** The class name to add to the component. */
  className: _propTypes.default.string,

  /**
   * Href to attach to the button. If this prop is supplied it
   * will render the component with an anchor tag.
   * */
  href: _propTypes.default.string,

  /** The size of the button. */
  size: _propTypes.default.oneOf(Object.values(_constants.buttonSizes)),

  /** The type of button (e.g, ghost-light, secondary, standalone etc) */
  type: _propTypes.default.oneOf(Object.values(_constants.buttonTypes)),

  /** The icon to be displayed in the button */
  icon: _propTypes.default.oneOf(Object.values(_Icons.icons)),

  /** Whether the button should be disabled. */
  isDisabled: _propTypes.default.bool,

  /** Whether the button should be rendered as a disc button. */
  isDisc: _propTypes.default.bool,

  /** Whether the button should be rendered as a disc button with a label. */
  label: _propTypes.default.string,

  /** Whether the button is the full width of its container at all breakpoints. */
  isFullWidth: _propTypes.default.bool,

  /** Display a loading spinner on button. */
  isLoading: _propTypes.default.bool,

  /** Display a success tick after loading. */
  isSuccess: _propTypes.default.bool,

  /** The Tooltip component that renders on hover */
  tooltip: _propTypes.default.node,

  /** The text to be rendered in the button */
  children: _propTypes.default.node
};
Button.defaultProps = {
  isDisabled: false,
  isFullWidth: false,
  isDisc: false,
  type: _constants.buttonTypes.PRIMARY,
  size: _constants.buttonSizes.MEDIUM
};
var _default = Button;
exports.default = _default;